import { Box, Typography } from '@mui/material'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { formatRegistrationDate } from '../../../../../components/common/time/timeHelper'
import '../../../../../components/utilities/renderJSON.scss'
import '../../KybToPdf/checks/checks.scss'
import { camelCaseFormatter } from '../../../../../components/utilities/formatters/camelCase'

export const ExpandablePropertyPDF = (props) => {

  return (
    <React.Fragment>
      {props.title && (
        <Typography variant="number" color="primary">
          {props.title}
        </Typography>
      )}
      {React.Children.count(props.children) === 0 ? ' ---' : <Box>{props.children}</Box>}
    </React.Fragment>
  )
}

export const RecursivePropertyPDF = (props) => {
  const { t } = useTranslation(['common'])

  const isDateKey = (key) =>
    key &&
    [
      'date',
      'fecha',
      'FirstMovementDate',
      'LastMovementDate',
      'createdAt',
      'updatedAt',
      'movementDate',
      'data',
      'dateOfBirth',
      'birthDate',
    ].some((k) => key.toLowerCase().includes(k.toLowerCase()))

  const translatedKey = props.propertyName
    ? t(`common:${props.propertyName}`) !== `common:${props.propertyName}`
      ? t(`common:${props.propertyName}`)
      : camelCaseFormatter(props.propertyName)
    : ''

  let displayValue = props.property
  if (isDateKey(props.propertyName)) {
    // Si es fecha válida, formatear
    const formatted = formatRegistrationDate(props.property)
    displayValue = formatted && formatted.endsWith('1901') ? '---' : formatted
  }

  return (
    <div>
      {props.property !== undefined &&
        props.propertyName !== 'resultados_sugeridos' &&
        props.propertyName !== 'site_receipt' &&
        (typeof props.property === 'number' ||
        typeof props.property === 'string' ||
        typeof props.property === 'boolean' ? (
          <div className="c-detail-row">
            {props.propertyName && (
              <Typography variant="subtitle1">{translatedKey}: </Typography>
            )}
            <Typography variant="subtitle3" className="c-detail-break-word">
              {props.property === '' ? '---' : displayValue?.toString()}
            </Typography>
          </div>
        ) : (
          <ExpandablePropertyPDF
            title={props.propertyName && translatedKey}
            expanded={!!props.rootProperty}
          >
            {props.property &&
              Object.values(props.property).map((property, index, { length }) => (
                <RecursivePropertyPDF
                  key={index}
                  property={property}
                  propertyName={Object.getOwnPropertyNames(props.property)[index]}
                  excludeBottomBorder={index === length - 1}
                />
              ))}
          </ExpandablePropertyPDF>
        ))}
    </div>
  )
}

export default RecursivePropertyPDF
